// extracted by css-extract-rspack-plugin
export default {"reactBlobTextarea":"TextArea-module__reactBlobTextarea__gv_3F","selectContrast":"TextArea-module__selectContrast__N4Wlg"};